import { TextInput, Textarea } from '@mantine/core';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Workflow } from '@/app/workflows/actions/interfaces';
import { useEditedWorkflowActions } from '@/app/workflows/contexts/editedWorkflows';
import { useWorkflow } from '../../../contexts/getWorkflow';

export enum ComponentType {
  TextInput = 'TextInput',
  TextArea = 'TextArea',
}

export type EditFieldProps = {
  type: ComponentType;
  defaultValue: string;
  setIsEdit: (isEdit: boolean) => void;
  field: 'name' | 'description';
  workflow: Workflow;
};

export function EditField({ defaultValue, setIsEdit, field, type, workflow }: EditFieldProps) {
  const inputRef = useRef<any>(null);
  const [value, setValue] = useState(defaultValue);
  const { updateWorkflowAttributes } = useWorkflow();

  const { markWorkflowAsEdited } = useEditedWorkflowActions();

  const onUpdate = useCallback(() => {
    updateWorkflowAttributes(field, value);
  }, [field, updateWorkflowAttributes, value]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (inputRef.current && !inputRef.current.contains(event.target as Node)) {
        setIsEdit(false);
        if (value !== defaultValue) {
          markWorkflowAsEdited(workflow.id);
          onUpdate();
        }
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setIsEdit, value, onUpdate, workflow, markWorkflowAsEdited, defaultValue]);

  if (type === ComponentType.TextInput) {
    return <TextInput ref={inputRef} value={value} onChange={(e) => setValue(e.currentTarget.value)} w='70%' />;
  }

  return <Textarea ref={inputRef} value={value} onChange={(e) => setValue(e.currentTarget.value)} autosize />;
}
